export default {
    "labels": {
        'input.message': 'Escreva uma mensagem...',
        'conversations.title': 'Atendimentos',
        'start.new': 'Novo atendimento',
        'empty.messages': 'Sem mensagens',
        'no.more.messages': 'Sem mais mensagens',
        'empty.conversations': 'Ainda nenhuma conversa',
        'no.more.conversations': 'Sem mais conversas',
        'search.placeholder': 'Procure...',
        'location.placeholder': 'Qual a sua localização',
        'members.title': 'Membros',
        'typing': 'escrevendo...',
        'is.typing': 'está digitando...',
        'online': 'Online',
        'offline': 'Offline',
        'clear.messages': 'Limpar Mensagens',
        'delete': 'Apagar',
        'reply': 'Responder',
        'location.share.title': 'Compartilhar localização',
        'my.location': 'Minha localização',
        'send': 'Enviar',
        'send.message': 'Enviar Mensagem',
        'smiley': 'Emojis',
        'close': 'Fechar',
        'edit': 'Editar',
        'save': 'Salvar',
        'file.attachment': 'Anexo',
        'file.attach.title': 'Anexar',
        'last.seen': 'Visto',
        'last.seen.on': 'Visto por último',
        'time.format.AM': 'AM',
        'time.format.PM': 'PM',
        'hour': ' hora',
        'min': ' min',
        'yesterday': 'Ontem',
        'hours': ' horas',
        'mins': ' mins',
        'ago': 'atrás',
        'admin': 'Administrador',
        'user': 'Usuário',
        'member': 'Membro',
        'you': 'Você',
        'away': 'Ausente',
        'closed.conversation.message': 'Esta conversa foi marcada como resolvida. Se você tiver outras dúvidas, basta enviar uma mensagem aqui ou iniciar uma nova conversa.',
        'search.faq': 'Procure nos FAQs...',
        'looking.for.something.else': 'Te ajudo em algo mais?',
        'no-faq-found': 'Estamos aqui para ajudar.',
        'talk.to.agent': 'Falar com um Supporter',
        'how.to.reachout': 'Como podemos entrar em contato com você?',
        'email.error.alert': 'Parece que você digitou um e-mail inválido',
        'conversation.rated': 'avaliou a conversa',
        'char.limit.warn': 'Mantenha sua mensagem dentro de 256 caracteres para ajudar o bot a entender facilmente',
        'limit.remove': 'Remover',
        'limit.characters': 'caracteres',
        'limit.remaining': 'restante',
        'lead.collection': {
            'email': 'Email',
            'name': 'Nome',
            'phone': 'Telefone de contato',
            'title': 'Atendimentos',
            'heading': 'Antes de começar, só precisamos de alguns detalhes para que possamos atendê-lo melhor',
            'submit': 'Começar uma conversa',
        },
        'csat.rating': {
            'CONVERSATION_RATED': 'Você avaliou a conversa',
            'RATE_CONVERSATION': 'Avalie sua conversa',
            'CONVERSATION_REVIEW_PLACEHOLDER': 'Adicione um comentário…',
            'OTHER_QUERIES': 'Tem outras dúvidas? ',
            'RESTART_CONVERSATION': 'Reinicie esta conversa ',
            'SUBMIT_RATING': 'Envie sua avaliação '
        },
        'page.title.on.new.message': 'Nova mensagem de ',
        'emoji.hover.text': {
            'poor': 'Pobre',
            'great': 'Ótima',
            'average': 'Média'
        },
        'rich.message': {
            'notification.preview': 'Mensagem'
        },
        'filter.conversation.list': {
            'ALL_CONVERSATIONS': 'Todos atendimentos',
            'ACTIVE_CONVERSATIONS': 'Atendimentos ativos',
            'HIDE_RESOLVED': 'Ocultar resolvido',
            'SHOW_RESOLVED': 'Mostrar resolvido'
        },
        'time.stamp': {
            'sec.ago': 'segundo atrás',
            'secs.ago': 'segundos atrás',
            'min.ago': 'min atrás',
            'mins.ago': 'mins atrás',
            'hr.ago': 'hr atrás',
            'hrs.ago': 'hrs atrás'
        },
        'voice.output': {
            'location': {
                'init': 'Um local foi compartilhado com você.',
                'lat': 'Latitude é ',
                'lon': 'e Longitude é '

            },
            'attachment': 'Você tem um anexo.'
        }
    }
}